import PageContainer from "../components/PageContainer";
import CategoryCardContainer from '../components/CategoryCardContainer';
import CategoryCard from "../components/CategoryCard";
import { waterCategories, airCategories, landCategories, snowCategories, bestViewsCategories } from "../data/categoryList";
import { useEffect, useState } from "react";
import ActivityTypeSelect from "../components/poolBar/ActivityTypeSelect";
import { useDispatch, useSelector } from "react-redux";
import { setNewFilters } from "../redux/filtersSlice";
import { useTranslation } from "react-i18next";
import { Helmet } from 'react-helmet-async';
import usePageTracking from "../hooks/usePageTracking";

const ChooseCategory = () => {
    const { pageTitle } = usePageTracking({
        pageTitle: "Scegli la categoria",
    })

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const filters = useSelector(state => state.filters);

    useEffect(() => {
        dispatch(setNewFilters({ category: ''}));
    }, [dispatch])
    const [array, setArray] = useState(null)
    useEffect(() => {
        if (filters.activityType) {
            switch (filters.activityType[0]) {
                case "Acqua":
                    setArray(waterCategories);
                    break;
                case "Aria":
                    setArray(airCategories);
                    break;
                case "Terra":
                    setArray(landCategories);
                    break;
                case "Neve":
                    setArray(snowCategories);
                    break;
                case "Best Views":
                    setArray(bestViewsCategories)
                    break;
                default:
                    break;
            }
        } else {
            setArray([
                ...waterCategories,
                ...airCategories,
                ...landCategories,
                ...snowCategories,
                ...bestViewsCategories
            ])
        }
    }, [filters.activityType])

    return (
        <PageContainer items="center">
            <Helmet>
                <title>{pageTitle} - TicinoWild</title>
                <meta name="description" content="Scegli fra le macro categorie disponibili: Acqua, Terra, Aria, Neve e Best View" />
                <link rel="canonical" href="https://ticinowild.ch/choose-category" />
                <meta property="og:title" content={`${pageTitle} - TicinoWild`} />
                <meta property="og:description" content="Scegli fra le macro categorie disponibili: Acqua, Terra, Aria, Neve e Best View" />
                <meta property="og:url" content="https://ticinowild.ch/choose-category" />
                <meta name="twitter:title" content={`${pageTitle} - TicinoWild`} />
                <meta name="twitter:description" content="Scegli fra le macro categorie disponibili: Acqua, Terra, Aria, Neve e Best View" />
            </Helmet>
            <h2>Scegli tra le categorie</h2>
            {/* activityType select */}
            <ActivityTypeSelect />

            <CategoryCardContainer>
                {
                    array && array.length > 0 && [...array]
                        .sort((a, b) => t(a.label).localeCompare(t(b.label)))
                        .map((element, index) => {
                            return (
                                <CategoryCard
                                    key={index}
                                    title={t(element.label)}
                                    photo={element.resizedPhoto}
                                    filterString={`category-${element.name}`}
                                />
                            )
                        })
                }
            </CategoryCardContainer>
        </PageContainer>
    )
}

export default ChooseCategory